import type { ElectronContext } from '@mimir/common/context/applicationContext';

export async function execFilePromise(electronContext: ElectronContext, cmd: string, args: string[]): Promise<string> {
  return new Promise((resolve, reject) => {
    electronContext.mainRequire('child_process').execFile(cmd, args, undefined, (err, value) => {
      if (err) {
        reject(err);
      } else {
        // no `options` definitely means stdout/stderr are `string`
        resolve(value as string);
      }
    });
  });
}


export async function execPromise(electronContext: ElectronContext, cmd: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const exec: (command: string, callback: (error: any, stdout: string, stderr: string) => void) => void = electronContext.mainRequire('child_process').exec;
    exec(cmd, (err, value) => {
      if (err) {
        reject(err);
      } else {
        resolve(value);
      }
    });
  });
}
